import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setRegion, setUsername } from "../../store/appInfo/data/action";
import MediaCard from "../base/MediaCard";
import Typography from "@mui/material/Typography";
import { saveLog, verifyToken } from "../api/api";
import { getToken } from "../../store/root/reducer";
import CustomAppBarLogout from "../layout/CustomAppBarLogout";
import { useTranslation } from 'react-i18next';

const arrCard = [
  {
    name: "Marche",
    photo: process.env.PUBLIC_URL + "/assets/marche.png",
  },
  {
    name: "Abruzzo",
    photo: process.env.PUBLIC_URL + "/assets/abruzzo.png",
  },
  {
    name: "Emilia Romagna",
    photo: process.env.PUBLIC_URL + "/assets/emilia.png",
  },
  {
    name: "Umbria",
    photo: process.env.PUBLIC_URL + "/assets/umbria.png",
  },
  {
    name: "Brazil",
    photo: process.env.PUBLIC_URL + "/assets/brazil.png",
  },
];

const italyRegions = ["marche", "abruzzo", "emilia romagna", "umbria"];
const brazilRegions = ["brazil"];

export default function RegionPage({ handleLogout }: any) {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const { t } = useTranslation();
  const currentToken = useSelector(getToken);

  // verifyToken()
  //   .then()
  //   .catch(() => {
  //     logout();
  //   });

  const logout = () => {
    handleLogout();
    navigate("/", { replace: true });
  };

  const handleChangeRegion = (newValue: any) => {
    if (newValue) {
      const jwtParts = currentToken!.split(".");
      if (jwtParts && jwtParts.length > 1) {
        const payloadInBase64UrlFormat = jwtParts[1];
        let parsedToken = JSON.parse(atob(payloadInBase64UrlFormat!));
        let region = null;
        if (italyRegions.includes(newValue.name.toLowerCase())) {
          region = "italy";
        } else if (brazilRegions.includes(newValue.name.toLowerCase())) {
          region = "brazil";
        }
        if (
          parsedToken.securflyRegion != null &&
          parsedToken.securflyRegion.toLowerCase().includes(region)
        ) {
          saveLog(
            "Caricati dati generali regione " + newValue.name + " su sito web",
          )
            .then()
            .catch((e) => console.error("error ", e));
          dispatch(setRegion(newValue.name.toLowerCase()));
          navigate("/home", { replace: false });
        } else {
          alert("Non hai accesso a questa regione");
        }
      }
    }
  };

  return (
    <div className="flex bg-primary flex-col w-full h-full">
      <div className="flex h-1-10 w-full z-1 bg-primary">
        <CustomAppBarLogout handleLogout={logout} />
      </div>
      <Typography
        variant="h3"
        component="div"
        sx={{
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "32px",
          marginTop: "50px",
        }}
      >
        {t('SELEZIONA_REGIONE')}
      </Typography>
      <div className="flex w-full h-full align-center justify-center wrap">
        {arrCard.map((card: any, index: number) => (
          <MediaCard
            sxCard={{
              height: 250,
              width: 150,
              minHeight: 200,
              minWidth: 150,
            }}
            sxImg={{
              height: "75%",
            }}
            sxName={{
              justifyContent: "center",
            }}
            key={index}
            card={card}
            onClickImage
            onClick={handleChangeRegion}
          />
        ))}
      </div>
    </div>
  );
}
